export default __webpack_public_path__ + "static/media/txt3_pc.adf686aa.png";